var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15216 7.99999L13.7614 3.39079C14.0795 3.07261 14.0795 2.55678 13.7614 2.23864C13.4432 1.92047 12.9274 1.92047 12.6092 2.23864L7.99998 6.84781L3.39082 2.2386C3.07268 1.92047 2.55685 1.92047 2.23867 2.2386C1.92046 2.55678 1.92046 3.07265 2.23863 3.39083L6.84779 7.99999L2.23863 12.6092C1.92046 12.9273 1.92046 13.4432 2.23863 13.7613C2.55685 14.0795 3.07268 14.0795 3.39082 13.7614L7.99998 9.15217L12.6092 13.7613C12.9274 14.0795 13.4432 14.0795 13.7614 13.7613C14.0795 13.4432 14.0795 12.9274 13.7614 12.6092L9.15216 7.99999Z",
    fill: "#007AC9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.0f65d7b49b7ec8da7335b23dc25369fc.svg";
export { ForwardRef as ReactComponent };